import * as React from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@mui/material';

const ProgressBar = React.memo(function ProgressBar({ value }) {
    const valueInPercent = value;

    return (
        <Box
            sx={{
                border: (theme) => `1px solid ${theme.palette.divider}`,
                position: 'relative',
                overflow: 'hidden',
                width: '100%',
                height: 26,
                borderRadius: 2,
            }}
        >
            <Typography
                sx={{
                    position: 'absolute',
                    lineHeight: '24px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                {`${valueInPercent.toLocaleString()} %`}
            </Typography>
            <Box
                sx={{
                    height: '100%',
                    maxWidth: `${valueInPercent}%`,
                    bgcolor: valueInPercent < 30 ? '#f44336' : valueInPercent <= 70 ? '#efbb5aa3' : '#088208a3',
                }}
            />
        </Box>
    );
});

export default function SMProgress({ value }) {
    return <ProgressBar value={Number(value)} />;
}
